import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import Detail from "./detail";
import DetailSide from "./detail-side";
import ConfirmationDlg from "../../../../components/ConfirmationDlg";

import { useParams } from "react-router-dom";
import { matar } from "../../../../api";
import { useReactToPrint } from "react-to-print";
import { downloadExcel } from "../../../../utils/exporter";
import Swal from "sweetalert2";

function Index() {
  const componentRef = useRef();
  let { assetId, groupId } = useParams();
  const [group, setGroup] = useState(null);
  useEffect(() => {
    if (assetId) {
      setSelectedAsset(assetId);
    }
    if (groupId) {
      getOne();
    }
  }, [assetId, groupId]);
  const getOne = async () => {
    const res = await matar.getOneGroup({ id: groupId });
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setGroup(data.MachineGroup);
      if (data.MachineGroup?.length) {
        setSelectedAsset(data.MachineGroup[0]?.machine_id);
      }
    }
  };
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("sort");
  const [list, setList] = React.useState([1]);
  const [value1, setValue1] = useState(100000);
  const [value2, setValue2] = useState(90000);
  const [slider1, setSlider1] = useState(40);
  const [slider2, setSlider2] = useState(60);
  const [assetGroup, setAssetGroup] = useState("All");
  const [asset, setAsset] = useState("All");
  const [dataForPrint, setDataForPrint] = useState([]);
  const [criticality, setCriticality] = useState("All");
  const [strategy, setStrategy] = useState("All");
  const [valueRandom, setValueRandom] = useState(0);
  const [listSimulation, setListSimulation] = useState([]);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const getStrategy = async () => {
    const result2 = await matar.getStrategy({
      machine_id: selectedAsset,
    });
    if (result2.ok) {
      const body = await result2.json();
      const data = body.data;
      setListSimulation(data);
    }
  };
  const fixStringToInt = (arr) => {
    const tmp = arr.map((item) => {
      return {
        ...item,
        cost: parseInt(item.cost) || null,
        capex: parseInt(item.capex) || null,
        opex: parseInt(item.opex) || null,
        year: parseInt(item.year) || null,
        start: parseInt(item.start) || null,
        duration: parseInt(item.duration) || null,
      };
    });
    //delete null value from the object of array
    const result = tmp.filter((item) => {
      return Object.values(item).some((value) => value !== null);
    });
    return result;
  };
  const changeStrategy = () => {
    setOpen(false);
    if (selectedSimulation === null) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a simulation",
      });
      return;
    }
    const sls = listSimulation.find((item) => item.id === selectedSimulation);
    const fetchByData = async (inc, dec, rep, ref) => {
      const result = await matar.calculateMatar({
        asset_id: selectedAsset,
        increase_pm: fixStringToInt(inc),
        decrease_pm: fixStringToInt(dec),
        replacement: fixStringToInt(rep),
        refurbishment: fixStringToInt(ref),
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data.simulation;
        setAllData([
          ...allData,
          {
            name: sls.financialStrategies.name,
            sls,
            data,
          },
        ]);
        const tmp = data.map((item) => {
          return {
            ...item,
            strategy: sls.financialStrategies.name,
          };
        });
        setDataForPrint([...dataForPrint, ...tmp]);
      }
    };

    if (sls) {
      const prameters = sls.parameters;
      let inc = [];
      let dec = [];
      let rep = [];
      let ref = [];
      if (prameters.increase_pm?.length > 0) {
        inc = prameters.increase_pm;
      }
      if (prameters.decrease_pm?.length > 0) {
        dec = prameters.decrease_pm;
      }
      if (prameters.replacement?.length > 0) {
        rep = prameters.replacement;
      }
      if (prameters.refurbishment?.length > 0) {
        ref = prameters.refurbishment;
      }
      fetchByData(inc, dec, rep, ref);
    }
  };

  useEffect(() => {
    setValueRandom(valueRandom + 1);
  }, [asset, assetGroup, criticality, strategy]);
  const formatNumber = (num) => {
    if (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "";
  };
  const handleClose = (result) => {
    setOpen(false);
  };
  const handleSubmit = (result) => {
    setOpen(false);
    setList([...list, list.length + 1]);
  };
  const [allData, setAllData] = useState([]);

  const getData = async () => {
    const result = await matar.calculateMatar({
      asset_id: selectedAsset,
    });
    if (result.ok) {
      const body = await result.json();
      const data = body.data.simulation;
      setAllData([
        {
          name: "AI Prediction",
          data,
        },
      ]);
      const tmp = data.map((item) => {
        return {
          ...item,
          strategy: "AI Prediction",
        };
      });
      setDataForPrint(tmp);
    }
  };
  useEffect(() => {
    if (selectedAsset) {
      getData();
      getStrategy();
    }
  }, [selectedAsset]);
  const downloadHandler = useReactToPrint({
    content: () => componentRef.current,
  });

  const downloadExcelHandler = async () => {
    downloadExcel(dataForPrint, "overview");
  };
  const setImplemented = async (sls) => {
    console.log({ allData, sls });
    setOpen(false);
    const result = await matar.markDefault({
      machine_id: selectedAsset,
      machine_strategy_id: sls?.sls?.id,
    });
    if (result.ok) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Successfully set as implemented",
      });
    }
  };
  return (
    <div>
      <ConfirmationDlg
        open={open}
        onClose={handleClose}
        onSubmit={changeStrategy}
        btnSubmitText={"Add For Comparison"}
        btnCancelText={"Cancel"}
      >
        <div className="text-center">
          <h4 className="text-theme">Add For Comparison</h4>
          <select
            value={selectedSimulation}
            onChange={(e) => {
              setSelectedSimulation(e.target.value);
            }}
            className="border-theme form-control text-theme text-center form-control-sm"
          >
            <option value="">- Initial - </option>
            {listSimulation.map((item) => (
              <option key={item.id} value={item.id}>
                {item?.financialStrategies?.name}
              </option>
            ))}
          </select>
        </div>
      </ConfirmationDlg>
      <h4 className="page-header">Investment Profile</h4>
      <div class="row mb-2">
        {assetId ? (
          <div class="col-sm-4 pt-3">
            <div className=" fw-bold small text-white ">
              Asset ID : <b>{selectedAsset}</b>
            </div>
          </div>
        ) : (
          <div className="col-sm-4">
            <div className=" fw-bold small text-white ">
              <div className={"from-group my-2 w-100"}>
                <label>Select Asset : </label>
                {group ? (
                  <select
                    value={selectedAsset}
                    onChange={(e) => setSelectedAsset(e.target.value)}
                    className={"form-control border-theme text-theme"}
                  >
                    {group.map((item, index) => (
                      <option
                        key={index}
                        value={item.machine_id}
                        className={"text-theme"}
                      >
                        {item.machine_id}
                      </option>
                    ))}
                  </select>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
      <div class="row">
        <div class="col-6">
          <div className={"d-flex mb-2"}>
            <button
              className="btn btn-outline-theme btn-sm"
              style={{ marginRight: "4px" }}
              onClick={() => {
                setSelected("side");
              }}
            >
              <i className="fa fa-chart-area"></i> Side by Side
            </button>
            <button
              onClick={() => {
                setSelected("sort");
              }}
              className="btn btn-outline-theme btn-sm"
            >
              <i className="fa fa-list"></i> Sort by Strategy
            </button>
          </div>
        </div>
        <div className={" col-6 mb-1 d-flex justify-content-end"}>
          <div>
            <button
              onClick={downloadExcelHandler}
              className="btn btn-outline-theme btn-sm"
              style={{ marginRight: "4px" }}
            >
              <i className="fa fa-file-excel"></i> Download Excel
            </button>
            <button
              className="btn btn-outline-theme btn-sm"
              onClick={downloadHandler}
            >
              <i className="fa fa-file-pdf"></i> Download PDF
            </button>
          </div>
        </div>
      </div>
      <div id="download-preview matar" ref={componentRef}>
        <div className={"print-header"}>
          <img src="/img/hamad_header.png" style={{ height: "80px" }} alt="" />
        </div>
        {selected === "sort" ? (
          allData.map((item, index) => {
            return (
              <div className={"page-break"}>
                <hr />
                <div className={"d-flex justify-content-between"}>
                  <h4>{item.name}</h4>
                  {index > 0 ? (
                    <div className={"d-flex"}>
                      <button
                        onClick={() => {
                          setImplemented(item);
                        }}
                        className={"btn btn-sm btn-outline-theme mb-1 "}
                        style={{ marginRight: "10px" }}
                      >
                        Set as Implemented
                      </button>
                    </div>
                  ) : null}
                </div>

                <Detail assetId={selectedAsset} allData={item.data} />
              </div>
            );
          })
        ) : (
          <DetailSide assetId={selectedAsset} allData={allData} />
        )}
      </div>

      <div className="d-flex justify-content-center">
        <div>
          <button
            className="btn btn-outline-theme btn-sm"
            onClick={() => {
              setOpen(true);
            }}
          >
            <i className="fa fa-plus"></i> Add Strategy
          </button>
          <button
            className="btn btn-outline-theme btn-sm"
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setList([1]);
            }}
          >
            <i className="fa fa-refresh"></i> Reset
          </button>
        </div>
      </div>
    </div>
  );
}

export default Index;
